<script setup lang="ts">
import Button from 'primevue/button'

const props = defineProps({
  variant: {
    type: String as PropType<'primary'|'secondary'|'tertiary'>,
    default: 'primary'
  }
})

const { variant } = toRefs(props)

const ptClass = computed(() => {
  let rootClass = 'border-2 rounded-full px-4 py-1.5 font-semibold select-none transition-colors '
  let labelClass = ''

  switch (variant.value) {
    case 'primary':
      rootClass += 'bg-brand-mustard-500 hover:bg-brand-mustard-500/70 border-brand-mustard-500 hover:border-brand-mustard-500/0 text-black disabled:opacity-40 disabled:cursor-not-allowed focus:outline-2 focus:outline-brand-mustard-500 focus-visible:_ring-3 focus:ring-0'
      break
    case 'secondary':
      rootClass += 'border-brand-mustard-500 hover:border-brand-mustard-500/70 disabled:opacity-40 disabled:cursor-not-allowed focus:outline-2 focus:outline-brand-mustard-200 focus:ring-0'
      break
    case 'tertiary':
      rootClass += 'border-none px-4.5 focus:outline-none focus:ring-0 group disabled:opacity-40'
      labelClass += 'border-b-2 border-brand-mustard-500 pb-2 group-hover:border-brand-mustard-500/70 group-focus-visible:border-double group-focus-visible:border-b-4'
  }

  return {
    root: rootClass,
    label: labelClass
  }
})

</script>
<template>
  <Button
    :pt="ptClass"
  >
    <slot />
  </Button>
</template>
